"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationChannels = void 0;
exports.PushNotificationChannels = [
    {
        id: "class reminder",
        name: "Class reminder",
        description: "Reminders for booked classes",
        trigger: "automatic",
        important: true,
    },
    {
        id: "class started",
        name: "Class started",
        description: "Alert when a booked class has started",
        trigger: "automatic",
        important: true,
    },
    {
        id: "class rescheduled",
        name: "Class rescheduled",
        description: "Alert when the time for a booked class has changed",
        trigger: "automatic",
        important: true,
    },
    {
        id: "class cancelled",
        name: "Class cancelled",
        description: "Alert when a booked class has been cancelled",
        trigger: "automatic",
        important: true,
    },
    {
        id: "new program",
        name: "New instructor programs",
        description: "Notify when a instructor you follow creates a new program",
        trigger: "automatic",
        important: true,
    },
    {
        id: "new blogpost",
        name: "New instructor blogposts",
        description: "Notify when a instructor you follow creates a new blogpost",
        trigger: "automatic",
        important: true,
    },
    {
        id: "account information",
        name: "Account updates",
        description: "Important information regarding your account",
        trigger: "automatic",
        important: true,
    },
    {
        id: "new content",
        name: "New content",
        description: "Curated updates about new content",
        trigger: "manual",
        important: true,
    },
    {
        id: "announcements",
        name: "Announcements",
        description: "New settings and features",
        trigger: "manual",
        important: true,
    },
    {
        id: "misc",
        name: "Miscellaneous",
        description: "Miscellaneous",
        trigger: "manual",
        important: false,
    },
    {
        id: "class starting in five",
        name: "Class starting in five",
        description: "Alert when a class starts in five minutes",
        trigger: "automatic",
        important: true,
    },
    {
        id: "new class",
        name: "New instructor class",
        description: "Notify when a instructor you follow creates a new session",
        trigger: "automatic",
        important: true,
    },
];
//# sourceMappingURL=PushNotification.js.map